var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("Ver"),
      _vm._v(" "),
      _c("VerReporte"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("people")]),
          _vm._v("\n      Vacaciones\n    ")
        ],
        1
      ),
      _vm._v(" "),
      _vm.funcionario === null
        ? _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _c(
                "v-card-text",
                { staticClass: "text-md-center" },
                [
                  _c("v-progress-circular", {
                    attrs: {
                      size: 70,
                      width: 7,
                      color: "primary",
                      indeterminate: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card-text",
        { staticClass: "grey lighten-2 text--info" },
        [
          _c(
            "v-layout",
            { attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                { staticClass: "px-3" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                        color: "primary",
                        to: "/listado-funcionarios-RRHH-vacaciones"
                      }
                    },
                    [_c("v-icon", [_vm._v("arrow_back")])],
                    1
                  ),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v("\n              Vacaciones\n            ")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _vm.funcionario !== null
            ? _c("v-card-text", { attrs: { elevation: "0" } }, [
                _c("p", [
                  _c("strong", [_vm._v("Nombre: ")]),
                  _vm._v(_vm._s(_vm.funcionario.nombre) + " ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("Cédula: ")]),
                  _vm._v(_vm._s(_vm.funcionario.nro_doc) + " ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("Fecha incorporación: ")]),
                  _vm._v(_vm._s(_vm.fecha_ingreso))
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("Total saldo vacaciones: ")]),
                  _vm._v(_vm._s(_vm.saldo) + " ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("Días a programar: ")]),
                  _vm._v(_vm._s(_vm.dias_a_programar) + " ")
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v(" Saldo de vacación no utilizada: ")]),
                  _vm._v(_vm._s(_vm.saldo_vacacion_no_usada) + " ")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "crud-table",
                {
                  attrs: {
                    headers: _vm.headers,
                    url: _vm.url,
                    filters: _vm.filters,
                    "data-graphql": _vm.dataGraphql,
                    graphql: _vm.graphql,
                    initData: _vm.initData
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(items) {
                        return [
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.fecha_desde))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.fecha_hasta))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.total_dias))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.estado))
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "info",
                                    icon: "",
                                    title: "Ver seguimiento"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.ver(items.item)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("remove_red_eye")])],
                                1
                              ),
                              _vm._v(" "),
                              !items.item.id_padre
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "#f3cb19",
                                        icon: "",
                                        title:
                                          "Ver reporte de programación de vacación"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.verReporte(items.item, 0)
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("picture_as_pdf")])],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              items.item.id_padre
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "#7b19d8",
                                        icon: "",
                                        title:
                                          "Ver reporte de reprogramación de vacación"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.verReporte(items.item, 1)
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("picture_as_pdf")])],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [_c("template", { slot: "buttons" })],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d492c17e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d492c17e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacaciones/VacacionRRHH.vue
// module id = null
// module chunks = 